;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{},n=(new Error).stack;n&&(e._sentryDebugIds=e._sentryDebugIds||{},e._sentryDebugIds[n]="ac0327a9-7f33-4706-a3a2-6a1ec2821dc8",e._sentryDebugIdIdentifier="sentry-dbid-ac0327a9-7f33-4706-a3a2-6a1ec2821dc8")}catch(e){}}();
(self["webpackChunkretino"] = self["webpackChunkretino"] || []).push([[261],{

/***/ 38037:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96540);
/* harmony import */ var helpers_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41906);
/* harmony import */ var public_api__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35750);
/* harmony import */ var stores_hooks__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9432);
/* harmony import */ var ui__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10775);
/* provided dependency */ var moment = __webpack_require__(95093);





function Coupon(_ref) {
  let {
    ticketId,
    remarketingSettingsId,
    shopName,
    color,
    textColor,
    voucherCode,
    value,
    currency,
    expirationDate,
    isPreview = false,
    min_price
  } = _ref;
  const publicApi = (0,public_api__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Ay)();
  const {
    copyToClipboard,
    openCopiedPopup
  } = (0,stores_hooks__WEBPACK_IMPORTED_MODULE_3__/* .useCopyToClipboard */ .Cj)();
  const [code, setCode] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(voucherCode);
  const [createVoucher, isCreatingVoucher] = (0,stores_hooks__WEBPACK_IMPORTED_MODULE_3__/* .useAsyncFunction */ .m_)(async () => {
    if (isPreview) {
      setCode('R37IN0');
      return;
    }
    const response = await publicApi.MarketplaceRemarketingCreateVoucherApi.create({
      settings_id: remarketingSettingsId,
      request: {
        ticket_id: ticketId
      }
    });
    setCode(response.code);
  });
  const hexToRgb = hexColor => {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hexColor);
    return result ? {
      r: parseInt(result[1], 16),
      g: parseInt(result[2], 16),
      b: parseInt(result[3], 16)
    } : null;
  };
  const isColorDark = rgbColor => {
    const y = (0.2126 * rgbColor.r + 0.7152 * rgbColor.g + 0.0722 * rgbColor.b) / 255;
    return y < 0.65;
  };
  const adjustShade = (clr, amount) => "#".concat(clr.replace(/^#/, '').replace(/../g, clrx => "0".concat(Math.min(255, Math.max(0, parseInt(clrx, 16) + amount)).toString(16)).substring(-2)));
  const getBgColor = hexColor => {
    const rgb = hexToRgb(hexColor);
    if (rgb && !isColorDark(rgb)) {
      return adjustShade(hexColor, -110);
    }
    return '#FFFFFF';
  };
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "relative flex w-full max-w-2xl items-center justify-between overflow-hidden rounded-md bg-white shadow-lg"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "absolute h-full w-4/5",
    style: {
      backgroundColor: getBgColor(color)
    }
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "absolute h-full w-4/5",
    style: {
      backgroundImage: "linear-gradient(to top right, ".concat(color, "b3, ").concat(color, ")")
    }
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "z-10 flex w-2/3 flex-col items-center p-2.5"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "text-center text-sm font-medium",
    style: {
      color: "".concat(textColor, "cc")
    }
  }, gettext('Discount on next purchase')), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "text-center text-sm font-medium",
    style: {
      color: textColor
    }
  }, shopName), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "mt-3 mb-4"
  }, !code && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(ui__WEBPACK_IMPORTED_MODULE_4__/* .Button */ .$n, {
    onClick: createVoucher,
    loading: isCreatingVoucher
  }, gettext('Reveal discount code')), code && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(ui__WEBPACK_IMPORTED_MODULE_4__/* .Popup */ .zD, {
    open: openCopiedPopup,
    position: "top center",
    trigger: /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
      role: "button",
      tabIndex: 0,
      className: "flex items-center justify-center gap-2 rounded-md bg-white/20 px-4 py-2 hover:cursor-pointer hover:bg-white/40",
      style: {
        color: textColor
      },
      onClick: copyToClipboard(code)
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
      className: "mt-px pt-px text-2xl font-extrabold leading-5 tracking-widest opacity-100",
      style: {
        fontFamily: 'monospace'
      }
    }, code), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
      className: "flex items-center justify-center",
      style: {
        color: "".concat(textColor, "cc")
      }
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(ui__WEBPACK_IMPORTED_MODULE_4__/* .Icon */ .In, {
      name: "clipboard-copy"
    })))
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "whitespace-nowrap text-sm text-gray-500"
  }, gettext('Copied to clipboard')))), expirationDate && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "flex gap-1 self-start text-xs",
    style: {
      color: "".concat(textColor, "cc")
    }
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    className: "whitespace-nowrap"
  }, gettext('This coupon is valid until')), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    className: "whitespace-nowrap"
  }, moment(expirationDate).format('l')), min_price && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    className: "whitespace-nowrap"
  }, gettext('for purchases over'), " ", (0,helpers_utils__WEBPACK_IMPORTED_MODULE_1__/* .formatPrice */ .$g)(min_price, currency)))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "absolute left-2/3 top-1/2 h-52 w-52 -translate-y-1/2 rounded-full bg-white"
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "text-blackp-2 z-10 flex w-1/3 justify-center text-2xl font-bold sm:text-3xl"
  }, (0,helpers_utils__WEBPACK_IMPORTED_MODULE_1__/* .formatPrice */ .$g)(value, currency)));
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Coupon);

/***/ }),

/***/ 90931:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96540);
/* harmony import */ var ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10775);


function PaddedLoader() {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "flex justify-center p-4"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(ui__WEBPACK_IMPORTED_MODULE_1__/* .Loader */ .aH, {
    size: "huge"
  }));
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (PaddedLoader);

/***/ }),

/***/ 58425:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96540);
/* harmony import */ var mobx_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44015);
/* harmony import */ var ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10775);



function FileItemUI(_ref) {
  let {
    fileName,
    url,
    isLoading,
    isUploaded = true,
    isFailed,
    errorCode,
    isUploading,
    percent,
    onRemove,
    onRetry
  } = _ref;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "rounded py-2 text-sm"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "flex items-center justify-between gap-4"
  }, isLoading ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(ui__WEBPACK_IMPORTED_MODULE_1__/* .Loader */ .aH, {
    size: "tiny"
  }) : url ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    href: url,
    target: "_blank",
    rel: "noopener noreferrer",
    className: "truncate"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(ui__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .$n, {
    link: true,
    fluid: true
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "truncate font-medium"
  }, fileName))) : /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "truncate font-medium"
  }, fileName), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "flex justify-center gap-8"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    className: "whitespace-nowrap text-gray-500"
  }, isUploading && percent && [Math.floor(percent), '%'].join(''), isUploaded && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(ui__WEBPACK_IMPORTED_MODULE_1__/* .Label */ .JU, {
    color: "green"
  }, gettext('Uploaded')), isFailed && !errorCode && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(ui__WEBPACK_IMPORTED_MODULE_1__/* .Label */ .JU, {
    color: "red"
  }, gettext('Failed')), errorCode === 'file_too_big' && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(ui__WEBPACK_IMPORTED_MODULE_1__/* .Label */ .JU, {
    color: "red"
  }, gettext('File should be smaller than 100MB'))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "flex items-center gap-2"
  }, isFailed && errorCode !== 'file_too_big' && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(ui__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .$n, {
    link: true,
    negative: true,
    icon: "refresh",
    onClick: onRetry
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(ui__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .$n, {
    grayLink: true,
    link: true,
    icon: "x",
    onClick: onRemove
  })))), !isUploaded && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "mt-1"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(ui__WEBPACK_IMPORTED_MODULE_1__/* .ProgressBar */ .z2, {
    failed: isFailed,
    progress: percent,
    done: isUploaded
  })));
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ((0,mobx_react__WEBPACK_IMPORTED_MODULE_2__/* .observer */ .PA)(FileItemUI));

/***/ }),

/***/ 44492:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: () => (/* binding */ form_controls_FileUploadField)
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(96540);
// EXTERNAL MODULE: ./node_modules/mobx-react/dist/mobxreact.esm.js + 14 modules
var mobxreact_esm = __webpack_require__(44015);
// EXTERNAL MODULE: ./node_modules/react-dropzone/dist/es/index.js + 5 modules
var es = __webpack_require__(30306);
// EXTERNAL MODULE: ./react/ui/index.ts + 2 modules
var ui = __webpack_require__(10775);
;// ./react/components/file-uploader/UploadFileButton.tsx




function UploadFileButton(_ref) {
  let {
    uploadFile,
    size,
    children,
    classNames = a => a,
    error = false
  } = _ref;
  const onDrop = files => files.forEach(file => uploadFile(file));
  const {
    getRootProps,
    getInputProps
  } = (0,es/* useDropzone */.VB)({
    onDrop
  });
  return /*#__PURE__*/react.createElement("div", getRootProps({
    style: {
      display: 'inline-block'
    }
  }), /*#__PURE__*/react.createElement("input", getInputProps()), /*#__PURE__*/react.createElement(ui/* Button */.$n, {
    icon: "paper-clip",
    classNames: classNames,
    size: size
  }, children));
}
/* harmony default export */ const file_uploader_UploadFileButton = ((0,mobxreact_esm/* observer */.PA)(UploadFileButton));
// EXTERNAL MODULE: ./react/public-api/index.tsx
var public_api = __webpack_require__(35750);
// EXTERNAL MODULE: ./react/components/file-uploader/FileItemUI.tsx
var FileItemUI = __webpack_require__(58425);
;// ./react/components/file-uploader/FileItem.tsx




function FileItem(_ref) {
  let {
    fileUploadId,
    onRemove
  } = _ref;
  const [fileUpload, setFileUpload] = (0,react.useState)();
  const api = (0,public_api/* default */.Ay)();
  (0,react.useEffect)(() => {
    const load = async () => {
      const response = await api.FilesFilesApi.retrieve({
        id: fileUploadId
      });
      setFileUpload(response);
    };
    load();
  }, [fileUploadId, api.FilesFilesApi]);
  return /*#__PURE__*/react.createElement(FileItemUI/* default */.A, {
    fileName: fileUpload === null || fileUpload === void 0 ? void 0 : fileUpload.filename,
    url: fileUpload === null || fileUpload === void 0 ? void 0 : fileUpload.file,
    isLoading: fileUpload === undefined,
    onRemove: onRemove
  });
}
/* harmony default export */ const file_uploader_FileItem = ((0,mobxreact_esm/* observer */.PA)(FileItem));
;// ./react/components/file-uploader/FileList.tsx




function FileList(_ref) {
  let {
    files,
    onRemove,
    classNames = a => a
  } = _ref;
  if (files === undefined || files.length === 0) {
    return null;
  }
  return /*#__PURE__*/react.createElement("div", {
    className: classNames(['space-y-2']).join(' ')
  }, files.map((fileUploadId, fileUploadIndex) => /*#__PURE__*/react.createElement("div", {
    key: fileUploadId
  }, /*#__PURE__*/react.createElement(file_uploader_FileItem, {
    fileUploadId: fileUploadId,
    onRemove: () => onRemove(fileUploadId)
  }), files.length > 1 && fileUploadIndex !== files.length - 1 && /*#__PURE__*/react.createElement(ui/* Divider */.cG, null))));
}
/* harmony default export */ const file_uploader_FileList = ((0,mobxreact_esm/* observer */.PA)(FileList));
;// ./react/components/file-uploader/index.tsx


;// ./react/components/file-uploader/UploadedFileItem.tsx



function UploadedFileItem_FileItem(_ref) {
  let {
    file,
    onRemove
  } = _ref;
  return /*#__PURE__*/react.createElement(FileItemUI/* default */.A, {
    fileName: file.rawFile.name,
    onRemove: onRemove,
    onRetry: file.retry,
    isUploaded: file.isUploaded,
    isUploading: file.isUploading,
    isFailed: file.isFailed,
    errorCode: file.errorCode,
    percent: file.percent
  });
}
/* harmony default export */ const UploadedFileItem = ((0,mobxreact_esm/* observer */.PA)(UploadedFileItem_FileItem));
;// ./react/components/file-uploader/UploadedFileList.tsx




function UploadedFileList(_ref) {
  let {
    files,
    onRemove
  } = _ref;
  if (files === undefined || files.length === 0) {
    return null;
  }
  return /*#__PURE__*/react.createElement("div", {
    className: "space-y-2"
  }, files.map((file, index) => /*#__PURE__*/react.createElement(react.Fragment, {
    key: file.id
  }, /*#__PURE__*/react.createElement(UploadedFileItem, {
    key: file.id,
    file: file,
    onRemove: () => onRemove(file)
  }), files.length > 1 && index !== files.length - 1 && /*#__PURE__*/react.createElement(ui/* Divider */.cG, null))));
}
/* harmony default export */ const file_uploader_UploadedFileList = ((0,mobxreact_esm/* observer */.PA)(UploadedFileList));
// EXTERNAL MODULE: ./node_modules/uuid/dist/esm-browser/v4.js + 3 modules
var v4 = __webpack_require__(33829);
// EXTERNAL MODULE: ./node_modules/mobx/dist/mobx.esm.js
var mobx_esm = __webpack_require__(27813);
// EXTERNAL MODULE: ./node_modules/superagent/lib/client.js
var client = __webpack_require__(15734);
var client_default = /*#__PURE__*/__webpack_require__.n(client);
// EXTERNAL MODULE: ./react/helpers/utils.ts
var utils = __webpack_require__(41906);
;// ./react/stores/UploadedFile.ts
var _dec, _dec2, _dec3, _dec4, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }


 // eslint-disable-line no-unused-vars


/**
 * Uploaded file is used for uploading files in circumvented way using direct S3 upload.
 */
let UploadedFile = (_dec = mobx_esm/* action */.XI.bound, _dec2 = mobx_esm/* action */.XI.bound, _dec3 = mobx_esm/* action */.XI.bound, _dec4 = mobx_esm/* action */.XI.bound, (_class = class UploadedFile {
  constructor(_ref) {
    let {
      api,
      file,
      onUploaded
    } = _ref;
    _initializerDefineProperty(this, "rawFile", _descriptor, this);
    _initializerDefineProperty(this, "id", _descriptor2, this);
    _initializerDefineProperty(this, "percent", _descriptor3, this);
    _initializerDefineProperty(this, "isUploaded", _descriptor4, this);
    _initializerDefineProperty(this, "isUploading", _descriptor5, this);
    _initializerDefineProperty(this, "isFailed", _descriptor6, this);
    _initializerDefineProperty(this, "errorCode", _descriptor7, this);
    this.api = void 0;
    this.uploadRequest = void 0;
    this.onUploaded = void 0;
    (0,mobx_esm/* makeObservable */.Gn)(this);
    this.id = (0,v4/* default */.A)();
    this.api = api;
    this.rawFile = file;
    this.onUploaded = onUploaded;
  }
  abort() {
    if (this.uploadRequest !== undefined) {
      this.uploadRequest.abort();
    }
  }
  destroy() {
    this.abort();
  }
  static uploadToS3(file, fileUploadRequest) {
    const formData = new FormData();
    formData.append('key', fileUploadRequest.s3_key);
    formData.append('x-amz-algorithm', fileUploadRequest.s3_x_amz_algorithm);
    formData.append('x-amz-credential', fileUploadRequest.s3_x_amz_credential);
    formData.append('x-amz-date', fileUploadRequest.s3_x_amz_date);
    formData.append('policy', fileUploadRequest.s3_policy);
    formData.append('x-amz-signature', fileUploadRequest.s3_x_amz_signature);
    formData.append('acl', 'public-read');
    formData.append('Content-Type', fileUploadRequest.content_type);
    formData.append('Content-Disposition', fileUploadRequest.content_disposition);
    formData.append('file', file);
    return client_default().post("".concat(fileUploadRequest.s3_url)).send(formData);
  }
  async upload() {
    if (!this.isUploaded && !this.isUploading) {
      this.isUploading = true;
      this.isUploaded = false;
      this.isFailed = false;
      this.errorCode = null;
      if (this.rawFile.type === 'image/heic') {
        try {
          this.rawFile = await (0,utils/* convertHeicToJpeg */.q2)(this.rawFile);
        } catch (e) {
          window.Sentry.captureException(e);
        }
      }
      const fileUploadRequest = await this.api.FilesFileUploadRequestApi.create({
        request: {
          filename: this.rawFile.name,
          content_type: this.rawFile.type || 'application/octet-stream'
        }
      });
      try {
        this.uploadRequest = UploadedFile.uploadToS3(this.rawFile, fileUploadRequest);
      } catch (error) {
        this.isFailed = true;
        this.isUploading = false;
        this.isUploaded = false;
        if ((error === null || error === void 0 ? void 0 : error.message) === 'File size exceeded') {
          this.errorCode = 'file_too_big';
        } else {
          this.errorCode = 'file_error';
        }
      }
      if (this.uploadRequest) {
        this.uploadRequest.on('progress', (0,mobx_esm/* action */.XI)(_ref2 => {
          let {
            percent
          } = _ref2;
          this.percent = percent;
        })).then((0,mobx_esm/* action */.XI)(async () => {
          this.isUploading = false;
          this.isUploaded = true;
          const backendConfirmation = await this.api.FilesFileUploadRequestUploadedApi.create({
            id: fileUploadRequest.id
          });
          if (backendConfirmation.status === 'UPLOADED') {
            if (this.onUploaded) this.onUploaded(backendConfirmation.file_upload, this);
          }
        })).catch((0,mobx_esm/* action */.XI)(() => {
          this.isUploading = false;
          this.isFailed = true;
          this.errorCode = 'upload_error';
        }));
      }
      return this.uploadRequest;
    }
    return undefined;
  }
  retry() {
    this.abort();
    this.upload();
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "rawFile", [mobx_esm/* observable */.sH], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "id", [mobx_esm/* observable */.sH], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "percent", [mobx_esm/* observable */.sH], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 0;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "isUploaded", [mobx_esm/* observable */.sH], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "isUploading", [mobx_esm/* observable */.sH], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "isFailed", [mobx_esm/* observable */.sH], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "errorCode", [mobx_esm/* observable */.sH], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _applyDecoratedDescriptor(_class.prototype, "abort", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "abort"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "destroy", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "destroy"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "upload", [_dec3], Object.getOwnPropertyDescriptor(_class.prototype, "upload"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "retry", [_dec4], Object.getOwnPropertyDescriptor(_class.prototype, "retry"), _class.prototype)), _class));
/* harmony default export */ const stores_UploadedFile = (UploadedFile);
;// ./react/components/form-controls/FileUploadField.tsx







const FileUploadField = /*#__PURE__*/(0,react.forwardRef)((_ref, ref) => {
  var _buttonClassNames, _fileListClassNames;
  let {
    label,
    onChange,
    value,
    error,
    setIsLoading,
    render,
    size,
    buttonClassNames,
    fileListClassNames
  } = _ref;
  buttonClassNames = (_buttonClassNames = buttonClassNames) !== null && _buttonClassNames !== void 0 ? _buttonClassNames : a => a;
  fileListClassNames = (_fileListClassNames = fileListClassNames) !== null && _fileListClassNames !== void 0 ? _fileListClassNames : a => a;
  const publicApi = (0,public_api/* default */.Ay)();
  const [uploadingFiles, setUploadingFiles] = (0,react.useState)([]);

  // This state is used as a queue before file upload ids will be sent to onChange
  const [fileUploadIdsQueue, setFileUploadIdsQueue] = (0,react.useState)([]);
  (0,react.useEffect)(() => {
    if (fileUploadIdsQueue.length > 0) {
      onChange([...(value !== null && value !== void 0 ? value : []), ...fileUploadIdsQueue]);
      setFileUploadIdsQueue([]);
    }
  }, [fileUploadIdsQueue]);
  const onFileUploaded = (fileUpload, uploadedFile) => {
    setUploadingFiles(old => old.filter(item => item.id !== uploadedFile.id));
    setFileUploadIdsQueue(old => [...old, fileUpload.id]);
  };
  const handleFileUpload = async file => {
    const uploadedFile = new stores_UploadedFile({
      api: publicApi,
      file,
      onUploaded: onFileUploaded
    });
    uploadedFile.upload();
    setUploadingFiles(old => [...old, uploadedFile]);
  };
  (0,react.useImperativeHandle)(ref, () => ({
    handleFileUpload(file) {
      handleFileUpload(file);
    }
  }));
  const handleUploadingFileRemove = file => {
    file.abort();
    setUploadingFiles(old => old.filter(item => item.id !== file.id));
  };
  (0,react.useEffect)(() => {
    if (setIsLoading) {
      setIsLoading(uploadingFiles.length > 0);
    }
  }, [uploadingFiles]);
  if (render) {
    return render({
      fileList: /*#__PURE__*/react.createElement(react.Fragment, null, /*#__PURE__*/react.createElement(file_uploader_FileList, {
        files: value,
        onRemove: removedId => onChange(value.filter(fileId => fileId !== removedId)),
        classNames: fileListClassNames
      }), (uploadingFiles === null || uploadingFiles === void 0 ? void 0 : uploadingFiles.length) > 0 && (value === null || value === void 0 ? void 0 : value.length) > 0 && /*#__PURE__*/react.createElement(ui/* Divider */.cG, null), /*#__PURE__*/react.createElement(file_uploader_UploadedFileList, {
        files: uploadingFiles,
        onRemove: handleUploadingFileRemove
      })),
      button: /*#__PURE__*/react.createElement(file_uploader_UploadFileButton, {
        classNames: buttonClassNames,
        size: size,
        uploadFile: handleFileUpload,
        error: !!error
      }, label ? /*#__PURE__*/react.createElement("strong", null, label) : null)
    });
  }
  return /*#__PURE__*/react.createElement(ui/* Form */.lV.Field, {
    error: error
  }, /*#__PURE__*/react.createElement("div", {
    className: "w-full space-y-2"
  }, /*#__PURE__*/react.createElement(file_uploader_FileList, {
    files: value,
    onRemove: removedId => onChange(value.filter(fileId => fileId !== removedId)),
    classNames: fileListClassNames
  }), (uploadingFiles === null || uploadingFiles === void 0 ? void 0 : uploadingFiles.length) > 0 && (value === null || value === void 0 ? void 0 : value.length) > 0 && /*#__PURE__*/react.createElement(ui/* Divider */.cG, null), /*#__PURE__*/react.createElement(file_uploader_UploadedFileList, {
    files: uploadingFiles,
    onRemove: handleUploadingFileRemove
  }), /*#__PURE__*/react.createElement(file_uploader_UploadFileButton, {
    classNames: buttonClassNames,
    size: size,
    uploadFile: handleFileUpload,
    error: !!error
  }, label ? /*#__PURE__*/react.createElement("strong", null, label) : null)));
});
/* harmony default export */ const form_controls_FileUploadField = ((0,mobxreact_esm/* observer */.PA)(FileUploadField));

/***/ }),

/***/ 82085:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93893);

const clientRoutes = {
  marketplaceBanner: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/marketplace/banner?remarketing_settings_id=:remarketingSettingsId&source=:source'),
  portalDirectLinkCompanyDetail: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/:lang/portal/direct-link/:companyId/'),
  ticketTicketDetail: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/:lang/client/:companyId/ticket/:ticketId/'),
  ticketTicketIdUnsubscribeHashcode: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/:lang/client/:companyId/ticket/:ticketId/unsubscribe/:hashcode/'),
  ticketTicketIdRatingRatingCommentDetail: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/:lang/client/:companyId/ticket/:ticketId/rating/:ratingCommentId/'),
  transportShippingIdRatingRating: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/:lang/client/:companyId/transport/:shippingId/rating/:rating/'),
  shippingShippingIdRatingRating: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/:lang/client/:companyId/shipping/:shippingId/rating/:rating/'),
  formFormDataDetail: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/:lang/client/:companyId/form/:formDataId/'),
  formFormDataIdCustomer: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/:lang/client/:companyId/form/:formDataId/customer/'),
  formFormDataIdPreForm: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/:lang/client/:companyId/form/:formDataId/pre-form/'),
  formFormDataIdOrderItems: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/:lang/client/:companyId/form/:formDataId/order-items/'),
  formFormDataIdProducts: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/:lang/client/:companyId/form/:formDataId/products/'),
  formFormDataIdTransport: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/:lang/client/:companyId/form/:formDataId/transport/'),
  formFormDataIdSummary: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/:lang/client/:companyId/form/:formDataId/summary/'),
  formFormDataIdSuccess: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/:lang/client/:companyId/form/:formDataId/success/'),
  formFormDataIdFail: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/:lang/client/:companyId/form/:formDataId/fail/'),
  formFormDataIdTicketDetail: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/:lang/client/:companyId/form/:formDataId/ticket-detail/'),
  form: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/:lang/client/:companyId/form/'),
  portal: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/:lang/client/:companyId/portal/'),
  shippingPortal: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/:lang/client/:companyId/shipping-portal/'),
  orderTracking: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/:lang/client/:companyId/order-tracking/'),
  trackAndTracePageDetail: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .url */ .OZ)('/:lang/client/:companyId/track-and-trace/:pageId/')
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (clientRoutes);

/***/ }),

/***/ 9432:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Cj: () => (/* binding */ useCopyToClipboard),
/* harmony export */   W6: () => (/* binding */ useHistory),
/* harmony export */   m_: () => (/* binding */ useAsyncFunction)
/* harmony export */ });
/* unused harmony export useAppStateLanguage */
/* harmony import */ var helpers_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41906);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96540);
/* harmony import */ var react_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47767);



function useAsyncFunction(fn, callback) {
  const [isLoading, setIsLoading] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
  const isMounted = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    isMounted.current = true;
    return () => {
      isMounted.current = false;
    };
  });
  const wrapper = async function () {
    setIsLoading(true);
    try {
      const result = await fn(...arguments);
      if (isMounted.current) {
        setIsLoading(false);
        if (callback) {
          callback();
        }
        return result;
      }
    } catch (error) {
      if (isMounted.current) {
        setIsLoading(false);
        throw error;
      }
    }
  };
  return [wrapper, isLoading];
}
function useAppStateLanguage(initial) {
  const [lang, setLang] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(initial || window.appState.lang);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    window.appState.lang = lang;
  }, [lang]);
  return [lang, setLang];
}
function useHistory() {
  const navigate = (0,react_router__WEBPACK_IMPORTED_MODULE_2__/* .useNavigate */ .Zp)();
  const location = (0,react_router__WEBPACK_IMPORTED_MODULE_2__/* .useLocation */ .zy)();
  const [listeners, setListeners] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(() => {
    listeners.forEach(func => func(location.pathname));
  }, [location.pathname]);
  const listen = func => {
    setListeners(old => [...old, func]);
    function unregisterCallback() {
      setListeners(old => (0,helpers_utils__WEBPACK_IMPORTED_MODULE_0__/* .toggleItem */ .g6)(old, func));
    }
    return unregisterCallback;
  };
  return {
    push: navigate,
    go: navigate,
    goBack: () => navigate(-1),
    goForward: () => navigate(1),
    listen,
    location
  };
}
function useCopyToClipboard() {
  const [openPopup, setOpenPopup] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
  const copyToClipboard = text => () => {
    const textarea = document.createElement('textarea');
    textarea.innerText = text;
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand('copy');
    textarea.remove();
    setOpenPopup(true);
    setTimeout(() => setOpenPopup(false), 1000);
  };
  return {
    copyToClipboard,
    openCopiedPopup: openPopup
  };
}
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ({
  useAsyncFunction,
  useAppStateLanguage
});

/***/ }),

/***/ 7777:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96540);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(46942);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);


function getOpacityFromProgress(progress) {
  if (progress <= 10) {
    return 'opacity-25';
  }
  if (progress > 10 && progress < 20) {
    return 'opacity-30';
  }
  if (progress > 20 && progress < 30) {
    return 'opacity-40';
  }
  if (progress >= 30 && progress < 40) {
    return 'opacity-50';
  }
  if (progress >= 40 && progress < 50) {
    return 'opacity-60';
  }
  if (progress >= 50 && progress < 60) {
    return 'opacity-70';
  }
  if (progress >= 60 && progress < 70) {
    return 'opacity-80';
  }
  if (progress >= 70 && progress < 80) {
    return 'opacity-90';
  }
  if (progress >= 80 && progress < 90) {
    return 'opacity-95';
  }
  return 'opacity-100';
}
function getColorFromProgress(progress, failed, gradient) {
  if (failed) {
    return ['bg-red-600'];
  }
  switch (progress) {
    case 100:
      return ['bg-green-500'];
    default:
      return ['bg-primary-600', gradient ? getOpacityFromProgress(progress) : ''];
  }
}
function ProgressBar(_ref) {
  let {
    progress = 10,
    failed = false,
    done = false,
    gradient = true,
    getColor = getColorFromProgress
  } = _ref;
  progress = Math.max(progress, 10);
  if (done || failed) {
    progress = 100;
  }
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "h-2 w-full space-y-3 rounded-full bg-gray-200"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    style: {
      width: "".concat(progress, "%"),
      transition: 'width 0.3s ease-in-out'
    },
    className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(['h-full', 'rounded-full', ...getColor(progress, failed, gradient)])
  }));
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ProgressBar);

/***/ }),

/***/ 60291:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ("https://cdn.retino.com/dist/files/react/img/shipping/dpd_logo.png");

/***/ }),

/***/ 46137:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ("https://cdn.retino.com/dist/files/react/img/shipping/logo_dhl.png");

/***/ }),

/***/ 34237:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ("https://cdn.retino.com/dist/files/react/img/shipping/logo_geis.png");

/***/ }),

/***/ 93193:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ("https://cdn.retino.com/dist/files/react/img/shipping/logo_gls.jpg");

/***/ }),

/***/ 65711:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ("https://cdn.retino.com/dist/files/react/img/shipping/logo_liftago.png");

/***/ }),

/***/ 14821:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ("https://cdn.retino.com/dist/files/react/img/shipping/logo_ppl.jpg");

/***/ }),

/***/ 36908:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ("https://cdn.retino.com/dist/files/react/img/shipping/logo_ppl_dhl.png");

/***/ }),

/***/ 19869:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ("https://cdn.retino.com/dist/files/react/img/shipping/logo_zasilkovna.png");

/***/ }),

/***/ 54518:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ("https://cdn.retino.com/dist/files/react/img/shipping/logo_zasilkovna_big.png");

/***/ }),

/***/ 42634:
/***/ (() => {

/* (ignored) */

/***/ }),

/***/ 22623:
/***/ (() => {

/* (ignored) */

/***/ })

}]);